import { render, staticRenderFns } from "./DownloadButton.vue?vue&type=template&id=ec0968b6&scoped=true"
import script from "./DownloadButton.vue?vue&type=script&lang=js"
export * from "./DownloadButton.vue?vue&type=script&lang=js"
import style0 from "./DownloadButton.vue?vue&type=style&index=0&id=ec0968b6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec0968b6",
  null
  
)

export default component.exports